var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_1374)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.420898,
    width: 13.3333,
    height: 2.11034,
    fill: "#71CEF3"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 5.69672,
    width: 10,
    height: 2.44832,
    fill: "#71CEF3"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10.9726,
    width: 13.3333,
    height: 2.44832,
    fill: "#71CEF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2456 8.25671L11.5262 8.37672L19.3059 11.7295L19.9998 12.0278V11.3231V8.42796V8.1409L19.7154 8.02088L16.8065 6.79334L19.6841 5.79951L19.9998 5.69143V5.38051V2.18005V1.47609L19.3059 1.77508L11.5262 5.12714L11.2456 5.24715V8.25671Z",
    fill: "#71CEF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_1374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13,
    fill: "white",
    transform: "translate(0 0.420898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCollapseIcon);
export default __webpack_public_path__ + "static/media/menu-collapse-icon.e4356c6fc635612d8bd05f06fed4d0be.svg";
export { ForwardRef as ReactComponent };